import { MainLayout } from '@/components/layout/MainLayout'
import { Dashboard } from '@/pages/admin/Dashboard'
import { TaskListPage, TaskCreatePage, TaskDetailPage } from '@/features/tasks'
import { ShipmentListPage, ShipmentDetailPage } from '@/features/shipments'
import { NomenclaturePage } from '@/features/nomenclature'
import { SettingsPage, SidebarSettingsPage, LabelTemplatesPage, FeatureGuard } from '@/features/settings'
import { CodeStructuresPage } from '@/pages/admin/CodeStructuresPage'
import { LabelEditorPage } from '@/features/label-editor'
import { KATemplatesPage, KAGenerationListPage, KAGenerationDocPage } from '@/features/ka-generation'
import { AdvancedPage, InfrastructurePage, ContractorsPage } from '@/features/advanced'
import { MetadataPage } from '@/features/metadata'
import { WorkerShipmentList } from '@/pages/worker/WorkerShipmentList'
import { WorkerShipmentDetail } from '@/pages/worker/WorkerShipmentDetail'
import { WorkerTaskListPage } from '@/pages/worker/WorkerTaskListPage'
import { WorkerTaskDetailPage } from '@/pages/worker/WorkerTaskDetailPage'
import { Navigate, type RouteObject } from 'react-router-dom'

/** Admin + worker routes shared by box and SaaS builds. */
export const sharedAppRoutes: RouteObject[] = [
  {
    path: '/admin',
    element: <MainLayout requiredRole="admin" />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'nomenclature', element: <NomenclaturePage /> },
      { path: 'tasks', element: <FeatureGuard flag="enable_tasks"><TaskListPage /></FeatureGuard> },
      { path: 'tasks/new', element: <FeatureGuard flag="enable_tasks"><TaskCreatePage /></FeatureGuard> },
      { path: 'tasks/:taskId', element: <FeatureGuard flag="enable_tasks"><TaskDetailPage /></FeatureGuard> },
      { path: 'shipments', element: <FeatureGuard flag="enable_shipments"><ShipmentListPage /></FeatureGuard> },
      { path: 'shipments/:shipmentId', element: <FeatureGuard flag="enable_shipments"><ShipmentDetailPage /></FeatureGuard> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'settings/label-templates', element: <LabelTemplatesPage /> },
      { path: 'settings/code-structures', element: <CodeStructuresPage /> },
      { path: 'label-editor', element: <LabelEditorPage /> },
      { path: 'label-editor/:templateName', element: <LabelEditorPage /> },
      { path: 'ka-templates', element: <KATemplatesPage /> },
      { path: 'ka-generation', element: <FeatureGuard flag="enable_ka_generation"><KAGenerationListPage /></FeatureGuard> },
      { path: 'ka-generation/:genId', element: <FeatureGuard flag="enable_ka_generation"><KAGenerationDocPage /></FeatureGuard> },
      { path: 'contractors', element: <ContractorsPage /> },
      { path: 'infrastructure', element: <InfrastructurePage /> },
      { path: 'advanced', element: <AdvancedPage /> },
      { path: 'metadata', element: <MetadataPage /> },
      { path: 'sidebar-settings', element: <SidebarSettingsPage /> },
    ],
  },
  {
    path: '/worker',
    element: <MainLayout requiredRole="worker" />,
    children: [
      { index: true, element: <Navigate to="tasks" replace /> },
      { path: 'tasks', element: <FeatureGuard flag="enable_tasks"><WorkerTaskListPage /></FeatureGuard> },
      { path: 'tasks/:taskId', element: <FeatureGuard flag="enable_tasks"><WorkerTaskDetailPage /></FeatureGuard> },
      { path: 'shipments', element: <FeatureGuard flag="enable_shipments"><WorkerShipmentList /></FeatureGuard> },
      { path: 'shipments/:shipmentId', element: <FeatureGuard flag="enable_shipments"><WorkerShipmentDetail /></FeatureGuard> },
    ],
  },
]
